<template>
  <a-modal
    :open="open"
    class="sequence-data"
    @cancel="handleClose"
    centered
    :maskClosable="false"
    :title="`Data de la secuencia “${sequenceName}”`"
    :width="1000"
    :bodyStyle="{ padding: '20px 0' }"
  >
    <span>
      Visualiza la actividad de tu secuencia con tus contactos. Recuerda que solo puedes obtener data de 1 mes como máximo.
    </span>
    <h3 class="subtitle">Seguimiento de contactabilidad</h3>
    <div class="data-totals">
      <div class="data-totals_item" v-for="itemLead in getLeadsCount()" :key="itemLead.key">
          <span>{{ data?.leads_data?.[itemLead.key] | 0 }}</span>
          <span>
            {{ itemLead.value }}
            <a-tooltip>
              <template #title>
                {{ SequenceLeadsDataInfo[itemLead.key] }}
              </template>
              <InfoCircleOutlined style="margin-left: 3px" />
            </a-tooltip>
          </span>
        </div>
    </div>
    <a-alert message="Los datos de seguimiento de contactabilidad no se actualizarán si se eliminan nodos en la secuencia." type="info" show-icon />

    <CustomScrollbar height="calc(100vh - 350px)" auto>
      <div class="container-subitems">
        <div class="data-items" v-for="item in data?.nodes_data" :key="item.id">
          <div class="data-items_item">
            <div>
              <component :is="IconByType[item.node_type]" class="icon" />
              <span class="node-name">{{ NodeTitleByType[item.node_type] }} </span>
              <span class="node-description">{{ item.node_title?.match(/\(([^)]+)\)/)?.[0] }}</span>
            </div>
            <span class="node-details">{{ nodeDescription(item) }}</span>
            <span class="actions__detail"
              >Siguiente acción: {{ ActionNameByType[item.node_action] }}</span
            >
          </div>
          <div class="data-subitems">
            <div style="display: flex; margin-left: 10px" v-for="subItem in getStatusCount(item)" :key="subItem.key">
              <a-divider class="divider-vertical" type="vertical" v-if="subItem.key == 'without_phone' || subItem.key == 'without_email'" />
              <div class="data-subitems_item">
                <p>{{ item.data?.[subItem.key] | 0 }}</p>
                <p>{{ subItem.value }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CustomScrollbar>

    <template #footer>
      <a-button class="footer_btn" @click="handleClose">Cerrar</a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { IconByType } from "@/app/flows/sequences/utils/icons";
import { sequenceService } from "@/app/flows/sequences/services/Sequence.service";
import { SequenceNodeType } from "@/@types/flows/sequences/index.ts";
import {
  SequenceLeadsDataText,
  SequenceLeadsDataInfo,
  SequenceLeadsStatusEmailText,
  SequenceLeadsStatusSmsText,
  SequenceLeadsStatusVoiceText,
  SequenceLeadsStatusWhatsappText,
} from "@/app/flows/sequences/utils/texts.ts";
import {
  NodeTitleByType,
  ActionNameByType,
  getNodeDescription,
} from "@/app/flows/sequences/utils/texts";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";

const props = defineProps<{ sequenceId: number; sequenceName: string; open: boolean }>();

const emit = defineEmits<{ "update:open": [open: boolean] }>();

const data = ref();

const fetchData = async () => {
  data.value = await sequenceService.getDataSequence(props.sequenceId);
  console.log(data.value, "data value");
};

const nodeDescription = (item: any) => {
  const node = {
    type: item.node_type,
    email_template: { name: item.template_name },
    queue: { name: item.queue_name },
    whatsapp_template: { name: item.template_name },
    ...item,
  };
  return getNodeDescription(node);
};

const getLeadsCount = (): any[] => {
  return Object.entries(SequenceLeadsDataText).map(
    ([key, value]) => ({ key, value })
  );
}

const getStatusCount = (item: any): any[] => {
  let statusArray: any[] = [];
  let statusTextConst: any;
  switch (item.node_type) {
    case SequenceNodeType.AutomaticCall:
      statusTextConst = SequenceLeadsStatusVoiceText;
      break;
    case SequenceNodeType.Email:
      statusTextConst = SequenceLeadsStatusEmailText;
      break;
    case SequenceNodeType.Whatsapp:
      statusTextConst = SequenceLeadsStatusWhatsappText;
      break;
    case SequenceNodeType.Sms:
      statusTextConst = SequenceLeadsStatusSmsText;
      break;
    default:
      break;
  }
  if (statusTextConst)
    statusArray = Object.entries(statusTextConst).map(
      ([key, value]) => ({ key, value })
    );
  return statusArray;
};

const handleClose = () => emit("update:open", false);

onMounted(() => fetchData());
</script>

<style scoped lang="sass">
.modal
  &__body
    color: $gray-9
    height: 400px
    display: grid
    grid-template-columns: repeat(4, 1fr)
    grid-template-rows: repeat(3, 1fr)
    gap: 12px

  &__picker
    margin-bottom: 12px

  &__paragraph
    margin: 16px 0

.data-totals
  background-color: $gray-3
  display: flex
  justify-content: space-between
  margin-top: 10px
  margin-bottom: 7px
  border: 1px solid #f0f0f0
  padding: 6px 20px
  border-radius: 8px
  border: 1px solid $gray-5
  &_item
    text-align: center
    display: inline-grid
    font-weight: 500

.data-items
  display: flex
  justify-content: space-between
  border: 1px solid #f0f0f0
  padding: 6px 20px
  border-radius: 8px
  border: 1px solid $gray-5
  position: relative
  &_item
    text-align: left
    display: inline-grid
  .data-subitems
    display: flex
    align-items: center
    &_item
      text-align: center
      // display: inline-grid
      min-width: 75px
      p
        margin-bottom: 0
        letter-spacing: 0.25px

.container-subitems
  margin-top: 18px
.container-subitems .data-items:not(:last-child)
  margin-bottom: 25px
.container-subitems .data-items:not(:last-child)::after
  content: ''
  position: absolute
  top: 100%
  left: 50%
  transform: translateX(-50%)
  width: 2px
  height: 26px
  background-color: $gray-5

.container-subitems .data-items:last-child
  margin-bottom: 0

.node
  border: 1px solid $gray-5
  border-radius: 8px
  padding: 12px
  width: 460px
  margin-bottom: 8px
  cursor: pointer

  &:hover
    border-color: $blue-6
    background-color: #E6F4FF

  &.selected
    border-color: $blue-6
    background-color: #E6F4FF

  &-name
    margin-right: 5px
    font-weight: 600
  &-name:first-letter
    text-transform: uppercase

  &-description
    color: $gray-7
    font-weight: 400
    margin-right: 5px
  &-details
    font-size: 13.5px

.actions
  &__detail
    color: $gray-7
    font-style: italic

.subtitle
  margin-top: 15px

.divider-vertical
  height: 50px
  margin-right: 10px

:global(.sequence-data .ant-modal-footer)
  text-align: center
:global(.footer_btn.ant-btn)
  width: 300px

:deep(.icon)
  color: $blue-6
  font-weight: 600
  font-size: 18px
  margin-right: 10px
</style>
